import React from 'react';

import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function BackButton({ pedagogical, id }) {
    return (
        <IconButton
            onClick={() => {
                const path = pedagogical ? `/pedagogical-videos/${id}` : `/movies/${id}`;
                window.location.href = path;
            }}
            className="player-back-button"
            title="Back"
        >
            <ArrowBackIcon fontSize="large" htmlColor="white" />
        </IconButton>
    );
}
